<template>
<v-flex mb-5 align-self-start v-if="semester">
    <v-layout px-3 my-5 align-center>
        <h1 class="text-xs-left display-2 my-2">Master Log Table</h1>
        <v-spacer></v-spacer>
        <h1 class="text-xs-left display-2 my-2">{{ semester.name }}</h1>
    </v-layout>
    <logs-data-table :logs="logs" :semester="semester.name"></logs-data-table>
</v-flex>

<v-flex v-else>
    <semester-not-found></semester-not-found>
</v-flex>
</template>

<script>
import DataTable from './DataTable'
import NotFound from '@/components/NotFound'

export default {
    components: {
        LogsDataTable: DataTable,
        SemesterNotFound: NotFound
    },
    computed: {
        logs() {
            return this.$store.state.admin.masterlogs
        },
        semester() {
            return this.$store.getters.semestersRouterFormat.find(s => s.slug === this.$route.params.semester_slug)
        },
    },
    created() {
        this.$store.dispatch('getMasterLogs', this.getSemesterName(this.$route.params.semester_slug))
    },
    beforeRouteUpdate(to, from, next) {
        if (to.path !== from.path) {
            this.$store.dispatch('getMasterLogs', this.getSemesterName(to.params.semester_slug))
        }
        next()
    },
    methods: {
        getSemesterName(slug) {
            let slugArray = slug.split('_')
            return slugArray[0].replace(/\-/gi, ' ')
        }
    }
}
</script>
